import { render, staticRenderFns } from "./TaskCapture.vue?vue&type=template&id=3ebc1a9f"
import script from "./TaskCapture.vue?vue&type=script&lang=js"
export * from "./TaskCapture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports